import { ConfirmExecutionComponent } from '@components/execution-process/execution-tasks/ConfirmExecutionComponent';
import { SectionValue } from '@components/FormFlow/Interfaces/IProcessValue';
import { ComponentType } from '@interfaces/component-type';
import styled, { Theme } from '@src/styled-components';
import React from 'react';

import DateExecutionComponent from './execution-tasks/DateExecutionComponent';
import GoToExecutionComponent from './execution-tasks/GoToExecutionComponent';
import NumberExecutionComponent from './execution-tasks/NumberExecutionComponent';
import PhotoExecutionComponent from './execution-tasks/PhotoExecutionComponent';
import SampleImageExecutionComponent from './execution-tasks/SampleImageExecutionComponent';
import SampleTextExecutionComponent from './execution-tasks/SampleTextExecutionComponent';
import ScoreExecutionComponent from './execution-tasks/ScoreExecutionComponent';
import SelectExecutionComponent from './execution-tasks/SelectExecutionComponent';
import TextExecutionComponent from './execution-tasks/TextExecutionComponent';
import TreeViewExecutionComponent from './execution-tasks/TreeViewExecutionComponent';
import IExecutionComponent from './interfaces/IExecutionComponent';
import CalculatorExecutionComponent from './execution-tasks/CalculatorExecutionComponent';
import { Result } from 'antd';
import I18n from '@src/i18n';
import FileUploadExecutionComponent from './execution-tasks/FileUploadExecutionComponent';
import moment from 'moment';
import ImageRecognitionExecutionComponent from './execution-tasks/ImageRecognitionExecutionComponent';

export interface ISectionExecutionProps extends IExecutionComponent {
  components: any;
  onClickGoto: (sectionId: string, fromGoToId: string, componentId: string, repeat: boolean) => void;
  onGotoDeleteData: Function;
  setRegisterSender: Function;
  sectionRegister?: SectionValue;
  totalScore: number;
  stackGoto: any;
  nextClickError: boolean
}

interface ISectionExecutionState {
  componentsRegister: any;
  score: any;
  resultCalculator: any;
}

export default class SectionExecutionComponent extends React.Component<ISectionExecutionProps, ISectionExecutionState> {
  constructor(props: ISectionExecutionProps) {
    super(props);
    this.state = {
      componentsRegister: [],
      score: 0,
      resultCalculator: false
    }

    this.onChange = this.onChange.bind(this);
    this.onChangeSectionClicked = this.onChangeSectionClicked.bind(this);
  }

  componentDidMount() {
    this.createRegister();
    if (this.props.setRegisterSender) this.props.setRegisterSender(this.onChangeSectionClicked);
  }

  UNSAFE_componentWillReceiveProps(props: any) {
    const { components } = this.props;
    if (components != props.components) {

    }
  }
  componentDidUpdate(prevProps: any) {
    //Received new components after changed section
    if (this.props.components != prevProps.components) {
      this.enteredNewSection();
    }
  }

  async enteredNewSection() {
    await this.createRegister();
    await this.updateRegister();
  }

  async createRegister() {
    const { components } = this.props;

    const register: any[] = [];

    for (const component of components) {
      const newCompRegister: any = {
        id: component.id,
        required: component.required,
        validation: false,
        value: undefined,
        type: component.type
      }

      if (component.type === 11) newCompRegister.results = component.results

      register.push(newCompRegister);
    }

    await this.setState({
      componentsRegister: register
    });
  }

  updateRegister() {
    const { sectionRegister } = this.props;
    const { componentsRegister } = this.state;
    const newComponentsRegister = [...componentsRegister];
    if (sectionRegister) {
      for (const sectionRegisterComp of sectionRegister.components) {
        const registerValIndex = newComponentsRegister.findIndex(c => c.id === sectionRegisterComp.id);
        if (registerValIndex != -1) {
          newComponentsRegister[registerValIndex] = {
            ...newComponentsRegister[registerValIndex],
            value: sectionRegisterComp.value,
            validation: componentsRegister[registerValIndex].type === 14 ? componentsRegister[registerValIndex].validation : sectionRegisterComp.validation,
          }
        }
      }
    }
    this.setState({ componentsRegister: newComponentsRegister });
  }

  async onChange(compVal: any, fromSectionId?: string) {    
    const { componentsRegister } = this.state;
    let compRegisterIndex = componentsRegister.findIndex((comp: any) => comp.id === compVal.id);
    let newRegisterVal = [...componentsRegister];
    if (compRegisterIndex != null && compRegisterIndex != undefined) {
      let regToChange = { ...componentsRegister[compRegisterIndex] };
      regToChange = { ...regToChange, value: compVal.value };
      compVal.file ? regToChange = { ...regToChange, file: compVal.file } : null; // @file monta arquivos file
      regToChange = { ...regToChange, validation: compVal.validation };
      newRegisterVal[compRegisterIndex] = regToChange;
    }
    let score = 0;
    this.props.components
      .filter((e: any) => e.type == ComponentType.SELECT)
      .forEach((e: any) => {
        const val = newRegisterVal.find((c: any) => c.id == e.id).value;
        if (Array.isArray(val) && val.length) {
          val.forEach(i => {
            score += e.options[i].weight;
          })
        }
      });
    let resultCalc = this.CalculateResult(newRegisterVal)
    if(resultCalc){
      resultCalc.forEach((r: any) => {
        let indexCalc = newRegisterVal.findIndex((e: any) => e.id === r.id)
        newRegisterVal[indexCalc].value = r.result; 
      })
    }
    await this.setState({ componentsRegister: newRegisterVal, score: score, resultCalculator: resultCalc });

  }
  CalculateResult(componentsRegister: any) {
    const { components } = this.props;
    let validFormula = true;
    let calcs = components.filter((e: any) => e.type == ComponentType.CALCULATOR)
    if (calcs.length > 0) {
      let regex = new RegExp(`{{${this.props.id}.|}}`, 'gm')
      let result = calcs.map((c: any) => {
        let valuesKeys = c.keys.map((k: string) => {
          let key = k.replace(regex, '');
          let valueComp = componentsRegister.filter((comp: any) => comp.id === key)
          return {
            key: key,
            value: valueComp[0].value ? valueComp[0].value[0] : null
          }
        })
        if (c.isDate) {
          let date1 = moment(valuesKeys[0].value)
          let date2 = moment(valuesKeys[1].value)
          let diff = date1 > date2 ? moment.duration(date1.diff(date2)).asMinutes() : moment.duration(date2.diff(date1)).asMinutes();
          return isNaN(diff) ? false : diff.toFixed(0)
        } else {
          let newFormula = c.formula.replace(regex, '');
          valuesKeys.map((v: any) => {
            if (typeof v.value === 'number') {
              newFormula = newFormula.replace(new RegExp(v.key, 'gm'), v.value)
            } else {
              validFormula = false;
            }
          })
          newFormula = newFormula.replace('--', '-')
          return {id: c.id, result: validFormula ? eval(newFormula) : false}
        }
      })
      return result
    } else {
      return false
    }
  }
  //Returns section values to execution (father component)
  async onChangeSectionClicked(next: boolean) {

    const validation = await this.validateRegister();
    const score = next ? this.state.score : 0;

    const compsValuesToReturn = {
      validation: validation,
      values: [...this.state.componentsRegister],
      score: score
    }
    await this.setState({ score: 0 }); //undo score current (click on preview)
    return compsValuesToReturn;
  }

  validateRegister() {
    const { componentsRegister } = this.state;
    if (componentsRegister.find((comp: any) => (comp.required && comp.validation === false || comp.validation && comp.validation[0] === false))) {
      return false;
    }
    return true;
  }

  renderComponentIsRequired(component: any) {

    if (component.required) {
      return <span style={{ color: 'red', marginRight: '8px' }}>*</span>
    }
    return;
  }

  getComponents() {
    let componetsSection: JSX.Element[] = [];
    const { sectionRegister, totalScore,nextClickError } = this.props;
    const { score, resultCalculator } = this.state;
    for (const [index, component] of this.props.components.entries()) {
      let compDefaultValue = undefined;
      if (sectionRegister) {
        const componentFromRegister = sectionRegister.components.find(c => c.id === component.id);
        if (componentFromRegister) {
          compDefaultValue = componentFromRegister.input;
            if(componentFromRegister.file) compDefaultValue = {
            value: componentFromRegister.input,
            fileList: componentFromRegister.file
          }
        }
      }
    const resultCalcComp = resultCalculator ? resultCalculator.find((r: any) => r.id === component.id) : false
      switch (component.type) {
        case (ComponentType.CONFIRM): {
          componetsSection.push(
            <React.Fragment key={index}>
              {this.renderComponentIsRequired(component)}
              <span>{component.title}</span>
              <div className='card'>
                <ConfirmExecutionComponent
                  key={component.id}
                  id={component.id}
                  description={component.description}
                  yesLabel={component.yesLabel}
                  noLabel={component.noLabel}
                  isRequired={component.required}
                  onChange={this.onChange}
                  defaultValue={compDefaultValue}
                />
              </div>
            </React.Fragment>
          )
        }
          break;
        case (ComponentType.TEXT): {
          componetsSection.push(
            <React.Fragment key={index}>
              {this.renderComponentIsRequired(component)}
              <span>{component.title}</span>
              <div className='card'>
                <TextExecutionComponent
                  key={component.id}
                  id={component.id}
                  description={component.description}
                  singleLine={component.singleLine}
                  required={component.required}
                  repeat={component.repeat}
                  onChange={this.onChange}
                  defaultValue={compDefaultValue}
                  minRepeat={component.minRepeat}
                  maxRepeat={component.maxRepeat}
                />
              </div>
            </React.Fragment>
          )
        }
          break;
        case (ComponentType.NUMBER): {
          componetsSection.push(
            <React.Fragment key={index}>
              {this.renderComponentIsRequired(component)}
              <span>{component.title}</span>
              <div className='card'>
                <NumberExecutionComponent
                  key={component.id}
                  id={component.id}
                  description={component.description}
                  repeat={component.repeat}
                  onChange={this.onChange}
                  defaultValue={compDefaultValue}
                  required={component.required}
                  min={component.min}
                  max={component.max}
                />
              </div>
              </React.Fragment>
          )
        }
          break;
        case (ComponentType.SAMPLETEXT): {
          componetsSection.push(
            <React.Fragment key={index}>
              <div className='card'>
                <SampleTextExecutionComponent
                  key={component.id}
                  title={component.title}
                />
              </div>
            </React.Fragment>
          )
        }
          break;
        case (ComponentType.SAMPLEIMAGE): {
          componetsSection.push(
            <React.Fragment key={index}>
              <span>{component.title}</span>
              <div className='card'>
                <SampleImageExecutionComponent
                  key={component.id}
                  description={component.description}
                  image={component.url}
                />
              </div>
            </React.Fragment>
          )
        }
          break;
        case (ComponentType.SCORE): {
          componetsSection.push(
            <React.Fragment key={index}>
              <span>{component.title}</span>
              <div className='card'>
                <ScoreExecutionComponent
                  key={component.id}
                  description={component.description}
                  results={component.results}
                  score={totalScore + score}
                />
              </div>
            </React.Fragment>
          )
        }
          break;
        case (ComponentType.DATE): {
          componetsSection.push(
            <React.Fragment key={index}>
              {this.renderComponentIsRequired(component)}
              <span>{component.title}</span>
              <div className='card'>
                <DateExecutionComponent
                  key={component.id}
                  id={component.id}
                  description={component.description}
                  repeat={component.repeat}
                  dateMin={component.min}
                  dateMax={component.max}
                  UseTodayMin={component.useToday}
                  UseTodayMax={component.useTodayMax}
                  onChange={this.onChange}
                  defaultValue={compDefaultValue}
                  minRepeat={component.minRepeat}
                  maxRepeat={component.maxRepeat}
                  required={component.required}
                  hour={component.hour}
                />
              </div>
            </React.Fragment>
          )
        }
          break;
        case (ComponentType.PHOTO): {
          componetsSection.push(
            <React.Fragment key={index}>
              {this.renderComponentIsRequired(component)}
              <span>{component.title}</span>
              <div className='card'>
                <PhotoExecutionComponent
                  key={component.id}
                  id={component.id}
                  description={component.description}
                  defaultValue={compDefaultValue}
                  repeat={component.repeat}
                  onChange={this.onChange}
                />
              </div>
            </React.Fragment>
          )
        }
          break;
        case (ComponentType.SELECT): {
          componetsSection.push(
            <React.Fragment key={index}>
              {this.renderComponentIsRequired(component)}
              <span>{component.title}</span>
              <div className='card'>
                <SelectExecutionComponent
                  key={component.id}
                  id={component.id}
                  description={component.description}
                  repeat={component.repeat}
                  options={component.options}
                  isMultiple={component.multiple}
                  onChange={this.onChange}
                  defaultValue={compDefaultValue}
                  minMultiple={component.minMultiple}
                  maxMultiple={component.maxMultiple}
                  required={component.required}
                />
              </div>
            </React.Fragment>
          )
        }
          break;
        case (ComponentType.GOTO): {
          componetsSection.push(
            <React.Fragment key={index}>
              {this.renderComponentIsRequired(component)}
              <span>{component.title}</span>
              <div className='card'>
                <GoToExecutionComponent
                  key={component.id}
                  id={component.id}
                  description={component.description}
                  repeat={component.repeat}
                  options={component.options}
                  isMultiple={component.multiple}
                  onClick={this.props.onClickGoto}
                  onDelete={this.props.onGotoDeleteData}
                  onChange={this.onChange}
                  defaultValue={compDefaultValue}
                  minMultiple={component.minMultiple}
                  required={component.required}
                  nextClickError={nextClickError}
                />
              </div>
              </React.Fragment>
          )
        }
          break;
        case (ComponentType.TREEVIEW): {
          componetsSection.push(
            <React.Fragment key={index}>
              {component.required === true && <span style={{ color: 'red' }} >*</span>}
              <span>{component.title}</span>
              <div className='card'>
                <TreeViewExecutionComponent
                  id={component.id}
                  onChange={this.onChange}
                  description={component.description}
                  treeView={component.items}
                  required={component.required}
                />
              </div>
            </React.Fragment>
          )
        }
          break;
        case (ComponentType.CALCULATOR): {
          componetsSection.push(
            <React.Fragment key={index}>
              <span>{component.title}</span>
              <div className='card'>
                <CalculatorExecutionComponent
                  key={component.id}
                  description={component.description}
                  results={component.results}
                  defaultResult={component.defaultResult}
                  resultCalculator={resultCalcComp ? resultCalcComp.result : false}
                  isDate={component.isDate}
                />
              </div>
            </React.Fragment>
          )
        }
          break;
        case (ComponentType.FILEUPLOAD): {
          componetsSection.push(
            <React.Fragment key={index}>
              <span>{component.title}</span>
              <div className='card'>
                <FileUploadExecutionComponent
                  key={component.id}
                  id={component.id}
                  description={component.description}
                  repeat={component.repeat}
                  onChange={this.onChange}
                  defaultValue={compDefaultValue}

                />
              </div>
            </React.Fragment>
          )
        }
          break;
        case (ComponentType.IMAGERECOGNITION): {
          componetsSection.push(
            <React.Fragment key={index}>
              <span>{component.title}</span>
              <div className='card'>
                <ImageRecognitionExecutionComponent
                  key={component.id}
                  id={component.id}
                  description={component.description}
                  configurationItems={component.configurationItems}
                  // repeat={component.repeat}
                  onChange={this.onChange}
                  defaultValue={compDefaultValue}
                  modelId={component.modelId}
                  projectId={component.projectId}

                />
              </div>
            </React.Fragment>
          )
        }
          break;
        default: {
          componetsSection.push(
            <div className='card'>
              <Result
                status="warning"
                title={I18n.l("formflow.components.unavailable")}
              />
            </div>
          )
        }
      }
    }
    return componetsSection;
  }
  //#endregion    


  render() {
    return (
      <ContentComponent>
        {this.getComponents()}
      </ContentComponent>
    );
  }
}

const ContentComponent = styled.div`
    
    margin-left: 15%;
    .card{
      width: 65%;
      padding-top: 25px;
      padding-left: 25px;
      padding-right: 25px;
      padding-bottom: 5px;
      background: ${Theme.secondary.darkWhite};
      border-radius: 5px;
      margin-top: 1rem;
      box-shadow: 4px 2px 10px -7px #B5B5B5;
      margin-bottom: 1rem;
    }
`;

// export const ConfirmExecutionComponent = ExecutionProcessContainer